export default "__VITE_ASSET__CRdRGw42__"